import axios from '@/jslib/axios'

export const setAccountReferralStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/status/set',
    data
  })
}

export const updateReferralRequestLimit = data => {
  return axios({
    method: 'post',
    url: '/admin/account/referral/request/limit',
    data
  })
}

export const addReferralRequest = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/add',
    data
  })
}

export const editReferralRequest = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/edit',
    data
  })
}

export const getReferralRequestList = params => {
  return axios({
    method: 'get',
    url: '/admin/account/referral/request/list',
    params
  })
}

export const convertReferralRequestRefer = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/convert/refer',
    data
  })
}

export const rejectReferralRequest = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/reject',
    data
  })
}

export const addReferralRequestManualPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/manual/policy',
    data
  })
}

export const setReferralRequestUser = data => {
  return axios({
    method: 'post',
    url: '/admin/referral/request/client_user',
    data
  })
}